import { element } from "angular";

editListPickerSectionController.$inject = ['$scope', '$mdDialog', '$translate', 'elementData', 'elementView'];
export function editListPickerSectionController($scope,
                                                $mdDialog,
                                                $translate,
                                                elementData,
                                                elementView) {
    $scope.cancel = cancel;
    $scope.ok = ok;

    init();
    function init() {
        $scope.elementData = elementData;
        $scope.elementView = elementView;
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function ok() {
        $mdDialog.hide({ type: 'ok', data: $scope.elementData });
    }
}